import {
    JOHN_DEERE_SHORT_ID_LENGTH,
    JOHN_DEERE_TAG_PREFIX,
    JOHN_DEERE_TAG_SUFFIX
} from './constants';
import type { JohnDeereTagParseResult } from './types';

export const parseJohnDeereTag = (name: string): JohnDeereTagParseResult | null => {
    const tagIndex = name.indexOf(JOHN_DEERE_TAG_PREFIX);

    if (tagIndex < 0) {
        return null;
    }

    const shortIdStart = tagIndex + JOHN_DEERE_TAG_PREFIX.length;
    const shortIdEnd = name.indexOf(JOHN_DEERE_TAG_SUFFIX, shortIdStart);

    if (shortIdEnd <= shortIdStart) {
        return null;
    }

    const shortId = name.substring(shortIdStart, shortIdEnd);
    const displayName = name.substring(0, tagIndex).replace(/\s+$/, '');

    return {
        displayName,
        shortId
    };
};

export const buildJohnDeereTag = ({ id, name }: { id: string; name: string }): string => {
    const shortId = id.substring(0, JOHN_DEERE_SHORT_ID_LENGTH);

    return `${name} ${JOHN_DEERE_TAG_PREFIX}${shortId}${JOHN_DEERE_TAG_SUFFIX}`;
};

export const hasJohnDeereTag = (name: string): boolean => parseJohnDeereTag(name) !== null;
